module.exports = __webpack_public_path__ + "media/吕工 (电影《我要我们在一起》配乐).b0060eb8.mp3";